export const cpdCategoryType = {
  core: 'CoreTopic',
  sub: 'SubTopic',
}

export const cpdCategoryTypeWithLabel = [
  {
    value: 'CoreTopic',
    label: 'Core Topic',
  },
  {
    value: 'SubTopic',
    label: 'Sub Topic',
  }
]


// WEBPACK FOOTER //
// ./src/constants/cpd-category-type.js